;globalThis["_sentryRouteManifest"] = "{\"dynamicRoutes\":[{\"path\":\"/blog/:slug\",\"regex\":\"^/blog/([^/]+)$\",\"paramNames\":[\"slug\"],\"hasOptionalPrefix\":false},{\"path\":\"/docs/:slug*?\",\"regex\":\"^/docs(?:/(.*))?$\",\"paramNames\":[\"slug\"],\"hasOptionalPrefix\":false},{\"path\":\"/features/:slug\",\"regex\":\"^/features/([^/]+)$\",\"paramNames\":[\"slug\"],\"hasOptionalPrefix\":false},{\"path\":\"/admin/:segments*?\",\"regex\":\"^/admin(?:/(.*))?$\",\"paramNames\":[\"segments\"],\"hasOptionalPrefix\":false}],\"staticRoutes\":[{\"path\":\"/about\"},{\"path\":\"/blog\"},{\"path\":\"/controller\"},{\"path\":\"/controller/case-studies\"},{\"path\":\"/controller/contact\"},{\"path\":\"/controller/core-integration-features\"},{\"path\":\"/controller/custom-application-development\"},{\"path\":\"/controller/faq\"},{\"path\":\"/controller/intelligent-energy-control\"},{\"path\":\"/controller/partner-program\"},{\"path\":\"/controller/pricing\"},{\"path\":\"/controller/pricing/configurator\"},{\"path\":\"/controller/starter-kit\"},{\"path\":\"/dc-quiz\"},{\"path\":\"/design-software\"},{\"path\":\"/design-software/contact\"},{\"path\":\"/design-software/features/annotations\"},{\"path\":\"/design-software/features/battery-charging\"},{\"path\":\"/design-software/features/bill-of-materials\"},{\"path\":\"/design-software/features/cloud-based\"},{\"path\":\"/design-software/features/in-app-communication\"},{\"path\":\"/design-software/features/in-app-support\"},{\"path\":\"/design-software/features/power-flow-simulation\"},{\"path\":\"/design-software/features/product-catalog\"},{\"path\":\"/design-software/features/prototyping\"},{\"path\":\"/design-software/features/realtime-collaboration\"},{\"path\":\"/design-software/features/validations\"},{\"path\":\"/design-software/features/wire-sizing\"},{\"path\":\"/mcp/consent\"},{\"path\":\"/resourcepro/create-account\"},{\"path\":\"/resourcepro/faq\"},{\"path\":\"/resourcepro/insider\"},{\"path\":\"/resourcepro/media-toolkit\"},{\"path\":\"/resourcepro/pricing\"},{\"path\":\"/resourcepro/qr-codes\"},{\"path\":\"/resourcepro/resources\"}],\"isrRoutes\":[\"/docs/:slug*?\"]}";globalThis["_sentryNextJsVersion"] = "16.3.8";globalThis["_sentryRewritesTunnelPath"] = "/monitoring";import * as Sentry from '@sentry/nextjs';

import { publicConfig } from '@public-config';

import { WorkspaceHelpers } from 'helpers/WorkspaceHelpers';

import { ImpersonationService } from 'services/ImpersonationService';

// Partner workspaces report under their own Sentry environment; the main site (DEP) keeps the regular one.
const workspace = WorkspaceHelpers.isWorkspace(window.location.host)
    ? WorkspaceHelpers.getConfig(window.location.host)?.key
    : undefined;
const isProduction = publicConfig.environment === 'production';

if (publicConfig.sentryPublicKey && (isProduction || workspace)) {
    const isImpersonating = ImpersonationService.isImpersonating();
    const isAdmin = window.location.pathname.startsWith('/admin');

    const noReplay = isImpersonating || isAdmin;

    Sentry.init({
        dsn: publicConfig.sentryPublicKey,
        environment: workspace ?? publicConfig.environment,
        tracesSampleRate: 0.5,
        replaysOnErrorSampleRate: noReplay ? 0 : 1,
        replaysSessionSampleRate: noReplay ? 0 : 1,
        sendDefaultPii: true,
        integrations: [
            Sentry.replayIntegration({
                maskAllText: false,
                maskAllInputs: false,
                blockAllMedia: false,
                networkDetailAllowUrls: ['directenergypartners.com'],
                networkResponseHeaders: ['x-user'],
            }),
            Sentry.replayCanvasIntegration(),
            Sentry.feedbackIntegration({
                autoInject: false,
                colorScheme: 'system',
                showBranding: false,
                useSentryUser: false,
                submitButtonLabel: 'Send feedback',
            }),
        ],
        // Errors thrown by injected browser extensions, not by us. See DEV-9690.
        ignoreErrors: [
            // We never call `new Proxy` directly, and valtio guards with its own "object required".
            'Cannot create proxy with a non-object as target or handler',
            "null is not an object (evaluating 'this.commandManager.commands')",
            // Deliberately narrow: something is stringifying a DOM node it grabbed off React's
            // internals. A plain circular-structure error of ours should still reach us.
            /Converting circular structure to JSON[\s\S]*__reactFiber/,
        ],
        beforeSend: (event) => {
            if (window.location.pathname.startsWith('/admin')) {
                return null;
            }

            const frames = event.exception?.values?.flatMap((value) => value.stacktrace?.frames ?? []) ?? [];

            if (frames.filter((frame) => frame.filename).every((frame) => isBrowserExtensionFrame(frame.filename))) {
                return null;
            }

            return event;
        },
    });
}

const isBrowserExtensionFrame = (filename?: string) =>
    !!filename &&
    (filename.startsWith('chrome-extension://') ||
        filename.startsWith('moz-extension://') ||
        filename.startsWith('safari-web-extension://') ||
        filename.startsWith('app:///executors/'));

export const onRouterTransitionStart = Sentry.captureRouterTransitionStart;
